import { API_URL as ENDPOINT } from "../config/env";

/** Columnas que el usuario quiere ver en una tabla. */
export async function PreferenciasTablaGet(tabla, token) {
  return fetch(`${ENDPOINT}PreferenciasTablaGet/${encodeURIComponent(tabla)}`, {
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
      Authorization: `${token}`,
    },
    method: "get",
  }).then((res) => res.json());
}

export async function PreferenciasTablaSave(data, token) {
  return fetch(`${ENDPOINT}PreferenciasTablaSave`, {
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
      Authorization: `${token}`,
    },
    method: "post",
    body: JSON.stringify(data),
  }).then((res) => res.json());
}
